import { Building2, Check, ChevronsUpDown, GitBranch, Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useSession } from "@/context/SessionContext";

const Row = ({ active, children, ...rest }) => (
  <DropdownMenuItem {...rest} className="flex items-center gap-2 cursor-pointer">
    <span className="flex-1 truncate">{children}</span>
    {active && <Check className="h-3.5 w-3.5 text-gold" />}
  </DropdownMenuItem>
);

export const CompanyBranchSwitcher = () => {
  const { me, company, branch, branches, companyId, branchId, setCompany, setBranch, isPlatform } = useSession();
  const companies = me?.companies || [];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="company-branch-switcher" className="flex items-center gap-2 rounded-md border bg-white px-2.5 py-1.5 text-left hover:border-[hsl(var(--gold)/0.6)] transition-colors max-w-[260px]">
          <Building2 className="h-4 w-4 text-gold shrink-0" />
          <div className="min-w-0 hidden sm:block">
            <div className="text-[13px] font-medium truncate" data-testid="active-company-name">{company?.name || "All companies"}</div>
            <div className="text-[11px] text-muted-foreground truncate" data-testid="active-branch-name">
              {company ? (branch ? branch.name : "All accessible branches") : "Platform view"}
            </div>
          </div>
          <ChevronsUpDown className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72">
        <DropdownMenuLabel className="g39-label">Company</DropdownMenuLabel>
        {isPlatform && (
          <Row active={!companyId} onSelect={() => setCompany("")} data-testid="switch-company-all">
            <span className="inline-flex items-center gap-2"><Globe className="h-3.5 w-3.5" /> All companies (platform)</span>
          </Row>
        )}
        {companies.map((c) => (
          <Row key={c.id} active={c.id === companyId} onSelect={() => setCompany(c.id)} data-testid={`switch-company-${c.code}`}>
            {c.name} {c.is_demo && <span className="text-[10px] text-amber-700 ml-1">DEMO</span>}
          </Row>
        ))}
        {companyId && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="g39-label">Branch</DropdownMenuLabel>
            <Row active={!branchId} onSelect={() => setBranch("")} data-testid="switch-branch-all">All accessible branches</Row>
            {branches.map((b) => (
              <Row key={b.id} active={b.id === branchId} onSelect={() => setBranch(b.id)} data-testid={`switch-branch-${b.code}`}>
                <span className="inline-flex items-center gap-2"><GitBranch className="h-3.5 w-3.5" />{b.name}</span>
              </Row>
            ))}
            {!branches.length && <div className="px-2 py-1.5 text-xs text-muted-foreground">No branches available</div>}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
